import { render, staticRenderFns } from "./OnboardPricing.vue?vue&type=template&id=95e16e8c&scoped=true"
import script from "./OnboardPricing.vue?vue&type=script&lang=ts"
export * from "./OnboardPricing.vue?vue&type=script&lang=ts"
import style0 from "./OnboardPricing.vue?vue&type=style&index=0&id=95e16e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e16e8c",
  null
  
)

export default component.exports